module.exports = __webpack_public_path__ + "media/images/browsers/edge-0867ca4d14a621ab9f4ec2ba425cedd9.svg";